import styled from 'styled-components';
import { BreakPoint } from '@makemydeal/dr-activities-common';

export const DashboardLifecycleBaseContainer = styled.div`
    text-align: right;

    .badge {
        font-size: 14px;
        padding: 4px 12px;
    }

    @media (max-width: ${BreakPoint.TABLET_PORTRAIT}) {
        text-align: left;
    }

    Button {
        padding: 0 0 0 0.9rem;
        font-weight: 500;
        font-size: 14px;

        &:focus {
            box-shadow: none;
        }

        @media (min-width: ${BreakPoint.SCREEN_SM_MIN}) {
            font-size: 16px;
        }
    }
`;
